import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { Flex } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: `/morpho/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            footer={true}
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.underlying_symbol,
                    address: data.underlying_address
                  }
                }
              }
            }}
          />

          <KpiCard
            title="Total Supply"
            variant="dai"
            data={data}
            field="supply"
            footer={true}
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.underlying_symbol,
                    address: data.underlying_address
                  }
                }
              }
            }}
          />

          <KpiCard
            title="Collateral"
            data={data}
            field="collateral_usd"
            footer={true}
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>

        <HistoricTabs />

        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="APY"
            data={data}
            field="total_rate_apy"
            options={{
              percentage: true
            }}
          />

          <KpiCard
            title="Unclaimed Profit"
            data={data}
            field="unclaimed"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>
      </>
    );
  }

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
